import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { puedeAcceder, tieneRol } from "../servicios/sesionSeguridad";
import { useStoreHome } from "../paginas/Home/useStoreHome";

export default function RutaConPermiso({ permiso, permisos, rol, requiereSuscripcion = false, children }) {
  const location = useLocation();
  const FechaCaducidad = useStoreHome((state) => state.FechaCaducidad);
  const CaducidadConsultada = useStoreHome((state) => state.CaducidadConsultada);
  const CargandoCaducidad = useStoreHome((state) => state.CargandoCaducidad);
  const requeridos = permisos || (permiso ? [permiso] : []);
  const permisoValido = requeridos.length === 0 || requeridos.some((codigo) => puedeAcceder(codigo));
  const rolValido = !rol || tieneRol(rol);

  useEffect(() => {
    if (requiereSuscripcion && !CaducidadConsultada && !CargandoCaducidad) {
      void useStoreHome.getState().obtenerCaducidad();
    }
  }, [CaducidadConsultada, CargandoCaducidad, requiereSuscripcion]);

  if (!permisoValido || !rolValido) {
    return <Navigate to="/home" replace state={{ accesoDenegado: true, from: location }} />;
  }

  if (requiereSuscripcion && !CaducidadConsultada) {
    return <div role="status" aria-live="polite">Verificando suscripción...</div>;
  }

  if (requiereSuscripcion && FechaCaducidad && FechaCaducidad < new Date()) {
    return <Navigate to="/home" replace state={{ suscripcionVencida: true, from: location }} />;
  }

  return children;
}
